import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Favorites from '../views/favorite/Favorites.vue'
import Proposals from '../views/Proposals.vue'
import MDResources from '../views/MDResources.vue'
import AgentResources from '../views/AgentResources.vue'
import Reports from '../views/Reports.vue'
import ShipmentsToDealers from '../views/ShipmentsToDealers.vue'
import UpdatesAndAlerts from '../views/UpdatesAndAlerts.vue'
import IConWebsite from '../views/IConWebsite.vue'
import RemittanceCloseCalendar from '../views/RemittanceCloseCalendar.vue'
import ReportView from '../views/ReportView.vue'
import AdminManagement from '../views/AdminManagement.vue'
import CostUserManagement from '../views/CostUserManagement.vue'
import Login from '../views/Login.vue'
import AlertDetail from '../views/AlertDetail.vue'
import ReinsuranceResources from '../views/ReinsuranceResources.vue'
import store from '../store'
import ICS from '@inventivegroup/vue-ics'
import { urlHelper } from "../util/UrlHelper"

Vue.use(VueRouter)
Vue.use(ICS, {})

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      public: true,
    },
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: Favorites,
  },
  {
    path: '/proposals',
    name: 'Proposals',
    component: Proposals,
  },
  {
    path: '/md-resources/:directoryId?',
    name: 'MD Resources',
    component: MDResources,
    props: (route) => ({
      ...route.params,
    }),
  },
  {
    path: '/reinsurance-resources/:path?',
    name: 'Reinsurance Resources',
    component: ReinsuranceResources,
    props: (route) => ({
      ...route.params,
    }),
  },

  {
    path: '/agent-resources/:directoryId?',
    name: 'Agent Resources',
    component: AgentResources,
    props: (route) => ({
      ...route.params,
    }),
  },
  {
    path: '/reports',
    name: 'ReportList',
    component: Reports,
  },
  {
    path: '/reports/:reportId/:reportName/:favorite',
    name: 'Reports',
    component: ReportView,
    props: (route) => ({
      ...route.params,
      favorite: route.params.favorite === 'true',
    }),
  },
  {
    path: '/shipments-to-dealers',
    name: 'Shipments to Dealers',
    component: ShipmentsToDealers,
  },
  {
    path: '/updates-and-alerts',
    name: 'Updates & Alerts',
    component: UpdatesAndAlerts,
  },
  {
    path: '/icon-website',
    name: 'iCon Website',
    component: IConWebsite,
  },
  {
    path: '/remittance-close-calendar',
    name: 'Remittance Close Calendar',
    component: RemittanceCloseCalendar,
  },
  {
    path: '/AlertDetail/:id',
    name: 'Alert Detail',
    component: AlertDetail,
    props: true,
  },
  {
    path: '/admins',
    name: 'Admin Management',
    component: AdminManagement,
    meta: {
      admin: true,
    },
  },
  {
    path: '/costUsers',
    name: 'Cost User Management',
    component: CostUserManagement,
    meta: {
      admin: true,
    },
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function isInDebug() {
  return !!(window as any).webpackHotUpdate
}

router.beforeEach((to, from, next) => {
  if (!to.meta) next()
  else if (to.meta.public) next()
  else if (to.meta.admin && store.state.user.isAdministrator) next()
  else if (to.meta.admin && !store.state.user.isAdministrator) {
    if (isInDebug()) {
      next({ name: 'Login' })
    } else {
      window.location.href = "/"
    }
  } else if (document.cookie.includes('APAUTH')) next()
  else {
    if (isInDebug()) {
      next({ name: 'Login' })
    } else {
      window.location.href = urlHelper.getApplicationUrl("login","?ReturnUrl=" + urlHelper.getApplicationUrl("agents", window.location.pathname))
    }
  }
})

export default router
